
export enum StreamDataType {
  AgentMessage = 'agent_message',
  AgentResponse = 'agent_response',
  AgentThinking = 'agent_thinking',
}

interface AgentCommon {
  type: StreamDataType;
  timestamp: string;
  message: string;
}

export interface AgentResponse extends AgentCommon {
  type: StreamDataType.AgentResponse;
  data?: object;
}

export interface AgentMessage extends AgentCommon {
  type: StreamDataType.AgentMessage;
  agentName: string;
}

export interface AgentThinking extends AgentCommon {
  type: StreamDataType.AgentThinking;
  data?: object;
}

export type StreamData = AgentMessage | AgentResponse | AgentThinking;
